import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article2026 from "../pages/article/cssbuy-spreadsheet-2026/page";
import ArticleOQueE from "../pages/article/cssbuy-o-que-e/page";
import ArticleComoUsar from "../pages/article/como-usar-cssbuy/page";
import ArticleVs from "../pages/article/cssbuy-vs-pandabuy-superbuy/page";
import ArticleMelhorAgent from "../pages/article/melhor-agent-china-spreadsheet/page";
import ArticleGuiaIniciantes from "../pages/article/guia-cssbuy-iniciantes/page";
import ArticleErros from "../pages/article/erros-cssbuy/page";
import ArticleEncontrar from "../pages/article/como-encontrar-produtos/page";
import ArticleQC from "../pages/article/cssbuy-qc-spreadsheet/page";
import ArticleEconomizar from "../pages/article/economizar-cssbuy/page";
import ArticleTopProdutos from "../pages/article/top-produtos-cssbuy/page";
import ArticleStreetwear from "../pages/article/streetwear-cssbuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet-2026",
    element: <Article2026 />,
  },
  {
    path: "/cssbuy-o-que-e",
    element: <ArticleOQueE />,
  },
  {
    path: "/como-usar-cssbuy",
    element: <ArticleComoUsar />,
  },
  {
    path: "/cssbuy-vs-pandabuy-superbuy",
    element: <ArticleVs />,
  },
  {
    path: "/melhor-agent-china-spreadsheet",
    element: <ArticleMelhorAgent />,
  },
  {
    path: "/guia-cssbuy-iniciantes",
    element: <ArticleGuiaIniciantes />,
  },
  {
    path: "/erros-cssbuy",
    element: <ArticleErros />,
  },
  {
    path: "/como-encontrar-produtos",
    element: <ArticleEncontrar />,
  },
  {
    path: "/cssbuy-qc-spreadsheet",
    element: <ArticleQC />,
  },
  {
    path: "/economizar-cssbuy",
    element: <ArticleEconomizar />,
  },
  {
    path: "/top-produtos-cssbuy",
    element: <ArticleTopProdutos />,
  },
  {
    path: "/streetwear-cssbuy",
    element: <ArticleStreetwear />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;